import { render } from "./resumeUpload.vue?vue&type=template&id=01b0029a&scoped=true"
import script from "./resumeUpload.vue?vue&type=script&lang=js"
export * from "./resumeUpload.vue?vue&type=script&lang=js"

import "./resumeUpload.vue?vue&type=style&index=0&id=01b0029a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\NASTYFACT\\Desktop\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b0029a"]])

export default __exports__